import { render, staticRenderFns } from "./trial-success.vue?vue&type=template&id=37990386&scoped=true&"
import script from "./trial-success.vue?vue&type=script&lang=js&"
export * from "./trial-success.vue?vue&type=script&lang=js&"
import style0 from "./trial-success.vue?vue&type=style&index=0&id=37990386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37990386",
  null
  
)

export default component.exports